const styles = (theme) => ({
  //InputWithChips
  inputWithChipsInput: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
  },

  //Chevron
  chevronIconContainer: {
    display: 'flex',
  },
  chevronIcon: {
    position: 'sticky',
    top: 5,
  },
  chevronIconDown: {
    transform: 'rotateZ(90deg)',
    width: 20,
    height: 20,
    opacity: 0.54,
  },
  chevronIconUp: {
    transform: 'rotateZ(270deg)',
    width: 20,
    height: 20,
    opacity: 0.54,
  },
  chevronRecipientCounter: {
    paddingTop: 5,
  },

  // Prompt
  promptDrawer: {
    padding: '10px 0',
  },

  promptButton: {
    textTransform: 'none',
    justifyContent: 'left',
    height: 60,
  },

  // Client search modal
  clientsSearchDrawer: {
    height: '100%',
  },
});

export default styles;
